import React, {Component} from 'react'
import { TeamCardStyle } from './../styles'

export default class TeamCard extends Component {
  state = {
    active: false
  }

  handlerClick = () => {
    this.setState({ active: !this.state.active })
  }

  render() {
    const { user } = this.props
    const { active } = this.state
    return (
      <div className={`team-line team ${TeamCardStyle(user.cover, active)}`}>
        <div className="team-inner">
          <div className="team-recto">
            <div className="flex">
              <div className="team-picture"></div>
              <div className="team-information">
                <h3 className="team-name"> {user.title} </h3>
                <div className="team-job"> {user.job} </div>
                {
                  user.description && (<span className="team-link" onClick={this.handlerClick}> Contact </span>)
                }
              </div>
            </div>
          </div>
          <div className="team-verso">
            <div className="team-close" onClick={this.handlerClick}></div>
            <h3 className="team-name"> {user.title} </h3>
            <div className="team-job"> {user.job} </div>
            { user.description && ( <div className="team-description" dangerouslySetInnerHTML={{ __html: user.description }} /> ) }
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/TeamCard.js